import {Action} from '@ngrx/store';
import {ArrayResponse} from '../../shared/models/array-response';
import {type} from '../../shared';
import {SelectedItem} from '../../order/models/order';
import {CompaniesFilter, CompaniesList} from '../models/companies-list';

export const companiesListActionTypes = {
  TOGGLE_SEARCH: type('[companies] Toggle Search Form'),
  QUICK_SEARCH: type('[companies] Quick Search'),
  SEARCH: type('[companies] Search'),
  CHANGE_PAGE_SIZE: type('[companies] Change Page Size'),
  PAGE_TO: type('[companies] Page To'),
  ORDER_BY: type('[companies] Order By'),
  LOAD: type('[companies] Load'),
  LOAD_SUCCESS: type('[companies] Load Success'),
  LOAD_FAIL: type('[companies] Load Fail'),
  SELECT_PAGE: type('[companies] Select Page'),
  UNSELECT_PAGE: type('[companies] Unselect Page'),
  TOGGLE_SELECTION: type('[companies] Toggle Selection'),
  TOGGLE_SELECTION_TAGS: type('[companies] Toggle Selection Tags'),
  CLEAR: type('[companies] Clear Data'),
  LOAD_MISSING_DATA: type('[companies] Missing data Load'),
};


export class ToggleSearchCompaniesAction implements Action {
  readonly type = companiesListActionTypes.TOGGLE_SEARCH;
  constructor(public payload?: boolean) {}
}

export class QuickSearchCompaniesAction implements Action {
  readonly type = companiesListActionTypes.QUICK_SEARCH;
  constructor(public payload?: string) {}
}

export class SearchCompaniesAction implements Action {
  readonly type = companiesListActionTypes.SEARCH;
  constructor(public payload?: CompaniesFilter) {}
}

export class ChangeCompaniesPageSizeAction implements Action {
  readonly type = companiesListActionTypes.CHANGE_PAGE_SIZE;
  constructor(public payload?: number) {}
}

export class PageCompaniesToAction implements Action {
  readonly type = companiesListActionTypes.PAGE_TO;
  constructor(public payload?: number) {}
}

export class OrderCompaniesByAction implements Action {
  readonly type = companiesListActionTypes.ORDER_BY;
  constructor(public payload?: string) {}
}

export class LoadCompaniesAction implements Action {
  readonly type = companiesListActionTypes.LOAD;
  constructor() {}
}

export class LoadCompaniesSuccessAction implements Action {
  readonly type = companiesListActionTypes.LOAD_SUCCESS;
  constructor(public payload?: ArrayResponse<CompaniesList>) {}
}

export class LoadCompaniesFailAction implements Action {
  readonly type = companiesListActionTypes.LOAD_FAIL;
  constructor(public payload?: string) {}
}
export class SelectCompaniesPageAction implements Action {
  readonly type = companiesListActionTypes.SELECT_PAGE;
  constructor() {}
}

export class UnselectCompaniesPageAction implements Action {
  readonly type = companiesListActionTypes.UNSELECT_PAGE;
  constructor() {}
}
export class ToggleCompaniesSitesSelectionAction implements Action {
  readonly type = companiesListActionTypes.TOGGLE_SELECTION;
  constructor(public payload?: SelectedItem) {}
}
export class ClearCompaniesAction implements Action {
  readonly type = companiesListActionTypes.CLEAR;
  constructor() {}
}
export class LoadCompaniesMissingDataAction implements Action {
  readonly type = companiesListActionTypes.LOAD_MISSING_DATA;
  constructor() {}
}


